import type { Meta, StoryFn } from '@storybook/react';

import { Count } from '@pega/cosmos-react-core';
import type { CountProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Badges/Count',
  component: Count
} as Meta;

export const CountBadge: StoryFn<CountProps> = (args: CountProps) => {
  return <Count variant={args.variant}>{args.children}</Count>;
};

CountBadge.args = {
  children: 3,
  variant: 'default'
};

CountBadge.argTypes = {
  children: { control: { type: 'number' } },
  variant: {
    options: ['default', 'urgent'],
    control: { type: 'select' }
  }
};
